var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[(_vm.is_web)?_c('div',{staticClass:"main-container"},[_c('app-main')],1):_vm._e(),(!_vm.is_web)?_c('router-tab'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }